import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import PickOneButton from "shared/components/PickOneButton";
import Str from "shared/components/Str";
import _str from "shared/util/_str";

import { IMPORTANCES } from "apps/questions/util/constants";

import "./index.scss";

if (process.env.PLATFORM === "desktop") {
	require("./index.desktop.scss");
} else {
	require("./index.mobile.scss");
}

class Importance extends Component {
	static propTypes = {
		importance: PropTypes.string,
		lastImportance: PropTypes.string,
		allAccepted: PropTypes.bool.isRequired,
		onChange: PropTypes.func.isRequired,
		disabled: PropTypes.bool.isRequired,
	}

	static defaultProps = {
		importance: null,
		lastImportance: null,
	}

	componentDidUpdate(prevProps) {
		const { allAccepted, onChange, lastImportance } = this.props;

		// when the user selects all answers as acceptable, set the importance to
		// "irrelevant"
		if (allAccepted && !prevProps.allAccepted) {
			onChange(IMPORTANCES.IRRELEVANT);
		}

		// when the user goes from irrelevant to unchecking one of the options, set
		// the importance to the last set one
		if (prevProps.allAccepted && !allAccepted) {
			onChange(lastImportance);
		}
	}

	_choices = [
		{ name: _str("A little"), value: IMPORTANCES.LITTLE },
		{ name: _str("Somewhat"), value: IMPORTANCES.SOMEWHAT },
		{ name: _str("Very"), value: IMPORTANCES.VERY },
	]

	render() {
		const { importance, allAccepted, disabled, onChange } = this.props;

		return (
			<Fragment>
				<Str className="questionspage-multipartquestion-label">
					Importance
				</Str>

				<PickOneButton
					choices={this._choices}
					value={importance}
					onChange={onChange}
					disabled={allAccepted || disabled}
					classRoot="importance"
				/>
			</Fragment>
		);
	}
}

export default Importance;



// WEBPACK FOOTER //
// ./src/apps/questions/components/Importance/index.jsx